import { Client, useReportForm } from 'modules/reports/hooks/useReportFormContext';
import styles from './client-chips.module.scss';

export const ClientChips = () => {
  const { formData, updateFormData } = useReportForm();

  const removeClient = (client: Client) => {
    const newClients = formData.clients.filter((c) => c.id !== client.id);
    updateFormData({ clients: newClients });
  };

  return (
    <div className={styles.container}>
      <p>Selected clients:</p>
      <div className={styles.chipContainer}>
        {formData.clients.map((client) => (
          <div key={client.id} className={styles.chip}>
            {client.clientName} {client.clientSurname}
            <button onClick={() => removeClient(client)} className={styles.removeButton}>
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
